// import polyfill
import 'core-js/es6/array';
import 'core-js/es6/string';
import 'core-js/es6/promise';

// import business
import './less/index.less';
import './less/resetelment.less';
import 'element-ui/lib/theme-chalk/index.css';
import './utils/axios';
import Vue from 'vue';
import VueRouter from 'vue-router';
import ElementUi from 'element-ui';
import store from './ducks';
import { routes } from './schema';
import * as lib from './components';
import VueQuillEditor from 'vue-quill-editor';
// import SpmFactory2 from 'qd-spm2';
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.use(VueQuillEditor);
Vue.use(VueRouter);
Vue.use(ElementUi);
// window.SpmFactory2 = SpmFactory2;

// 自动注册  手机端组件
Object.keys(lib).forEach(name => {
  Vue.component(`ex-${name.toLowerCase()}`, lib[name]);
});

const router = new VueRouter({
  mode: 'history',
  fallback: true,
  routes: [
    ...routes,
    { path: '*', component: lib.PcNoMatch },
  ],
});

router.beforeEach(function (to, from, next) {
  console.log('全局导航守卫',to,from);
  if (process.env.DEBUG_ENV === 'simulation') {
    next();
    return;
  }
  if(window.top.location.hostname == 'zh.jianyewy.com' || window.top.location.hostname == 'qazh.jianyewy.com') {
    let _url = window.top.location.protocol + '//' + (window.top.location.hostname == 'qazh.jianyewy.com' ? 'qaportal.jianyewy.com' : 'portal.jianyewy.com');
    window.top.location.replace(_url + "/index.html");
    next(false);
    return false;
  }
  // 罗盘嵌入 在线客服过滤
  // if (to.path.match('/skyline')) {
  //   // 按钮
  //   if (document.getElementById('MEIQIA-BTN-HOLDER')) {
  //     document.getElementById('MEIQIA-BTN-HOLDER').style.display = 'block';
  //   }
  //   // 弹框
  //   if (document.getElementById('MEIQIA-PANEL-HOLDER')) {
  //     document.getElementById('MEIQIA-PANEL-HOLDER').style.display = '';
  //   }
  // } else {
  //   // 按钮
  //   if (document.getElementById('MEIQIA-BTN-HOLDER')) {
  //     document.getElementById('MEIQIA-BTN-HOLDER').style.display = 'none';
  //   }
  //   // 弹框
  //   if (document.getElementById('MEIQIA-PANEL-HOLDER')) {
  //     document.getElementById('MEIQIA-PANEL-HOLDER').style.display = 'none';
  //   }
  // }
  if (!to.path.match(/^\/wx\/account/) && to.path.match(/^\/wx/) && !sessionStorage.getItem('wxAccount')) {
    router.push('/wx/account');
    // store.dispatch({
    //   type: 'showModal',
    //   modal: {
    //     title: '抱歉',
    //     message: '请先授权公众号',
    //     buttons: [{
    //       text: '确定',
    //       click: () => {
    //         store.dispatch('hideModal');
    //         router.push('/wx/account');
    //         // location.href = store.state.authUrl;
    //       },
    //     }],
    //   },
    // });
  }
  else if(to.path==='/account/login'){
    if(localStorage.getItem('loginAddress')&&(localStorage.getItem('source')=='gateway')){
      // 有自定义登录地址，并且来源于网关重定向时才跳转至自定义登录页
      window.top.location.href=localStorage.getItem('loginAddress');
      next(false);
    }
    else{
      next();
    }
  }
  else {
    next();
  }
});

window.top.vm=new Vue({ store, router }).$mount('#bootstrap');
